//for-formated
import { gql } from 'graphql-request'

export const GET_GAME = gql`
  query GET_GAME($gameId: Int!) {
    getGame(gameId: $gameId) {
      error
      status
      data {
        id
        name
        description
        url
        height
        imgLogo
        gameKey
        gameLabel
        gameSection
        slotGameId
        active
        deleted
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_GAMES = gql`
  query GET_GAMES(
    $take: Int
    $skip: Int
    $name: String
    $description: String
    $url: String
    $imgLogo: String
    $gameKey: String
    $gameLabel: String
    $gameSection: String
    $active: Boolean
    $deleted: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getGames(
      take: $take
      skip: $skip
      name: $name
      description: $description
      url: $url
      imgLogo: $imgLogo
      gameKey: $gameKey
      gameLabel: $gameLabel
      gameSection: $gameSection
      active: $active
      deleted: $deleted
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      totalPages
      data {
        id
        name
        description
        url
        height
        imgLogo
        gameKey
        gameLabel
        gameSection
        slotGameId
        active
        deleted
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_GAME_FIRST = gql`
  query GET_GAME_FIRST(
    $id: Int
    $name: String
    $description: String
    $url: String
    $imgLogo: String
    $gameKey: String
    $gameLabel: String
    $gameSection: String
    $active: Boolean
    $deleted: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getGameFirst(
      id: $id
      name: $name
      description: $description
      url: $url
      imgLogo: $imgLogo
      gameKey: $gameKey
      gameLabel: $gameLabel
      gameSection: $gameSection
      active: $active
      deleted: $deleted
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        id
        name
        description
        url
        height
        imgLogo
        gameKey
        gameLabel
        gameSection
        slotGameId
        active
        deleted
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_GAME_COUNT = gql`
  query GET_GAME_COUNT(
    $name: String
    $description: String
    $url: String
    $imgLogo: String
    $gameKey: String
    $gameLabel: String
    $gameSection: String
    $active: Boolean
    $deleted: Boolean
    $typeFilterCreatedAt: TypeFilter
    $createdAtInitial: String
    $createdAtFinal: String
  ) {
    getGameCount(
      name: $name
      description: $description
      url: $url
      imgLogo: $imgLogo
      gameKey: $gameKey
      gameLabel: $gameLabel
      gameSection: $gameSection
      active: $active
      deleted: $deleted
      typeFilterCreatedAt: $typeFilterCreatedAt
      createdAtInitial: $createdAtInitial
      createdAtFinal: $createdAtFinal
    ) {
      error
      status
      data {
        count
      }
    }
  }
`
